<template>
  <div
    v-if="auth?.roles"
    class="box flex h-full max-h-full flex-col rounded-lg print:hidden"
  >
    <!--region header-->
    <div class="relative flex shrink-0 items-center px-4 pt-4 pb-2">
      <h2 class="text-2xl font-bold capitalize-first">
        {{ $t('global.invoicing') }}
      </h2>
    </div>
    <!--endregion-->

    <div class="flex-1 overflow-auto overflow-x-hidden">
      <div class="space-y-1 border-t border-gray-200 p-4 dark:border-slate-600">
        <InvoicingMenuLink
          route-name="invoice_index_route"
          icon="file-invoice"
          :label="$t('global.invoice')"
          :new-route-name="newRouteFor('INV', 'invoice_form_new_route')"
        />
        <InvoicingMenuLink
          route-name="invoice_unpaid_index_route"
          icon="alarm-exclamation"
          :label="$t('global.unpaid')"
          indent
        />
        <InvoicingMenuLink
          route-name="invoice_paid_index_route"
          icon="badge-dollar"
          :label="$t('global.paid')"
          indent
        />
      </div>

      <template v-if="!isCustomerUser">
        <div
          class="space-y-1 border-t border-gray-200 p-4 dark:border-slate-600"
        >
          <InvoicingMenuLink
            route-name="invoicing_purchase_order_index_route"
            icon="file-invoice"
            :label="$t('global.purchase_order')"
            :new-route-name="
              newRouteFor('PO', 'invoicing_purchase_order_new_route')
            "
          />
          <InvoicingMenuLink
            route-name="invoicing_quote_index_route"
            icon="file-invoice"
            :label="$t('global.quote')"
            :new-route-name="newRouteFor('QUO', 'invoicing_quote_new_route')"
          />
          <InvoicingMenuLink
            route-name="invoicing_credit_note_index_route"
            icon="file-invoice"
            :label="$t('global.credit_note')"
            :new-route-name="
              newRouteFor('CN', 'invoicing_credit_note_new_route')
            "
          />
        </div>

        <div
          class="space-y-1 border-t border-gray-200 p-4 dark:border-slate-600"
        >
          <InvoicingMenuLink
            route-name="check_index_route"
            icon="money-check-alt"
            :label="$t('global.checks')"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import InvoicingMenuLink from './InvoicingMenuLink.vue'

export default {
  name: 'InvoicingNav',
  components: { InvoicingMenuLink },
  computed: {
    ...mapGetters({
      settings: 'settings/getSystemSettings',
      auth: 'auth/getAuth'
    }),
    isCustomerUser() {
      return this.auth?.roles?.[0] === 'customer-user'
    },
    availableDocs() {
      return Object.values(this.settings?.invoicing?.available_docs ?? {})
    }
  },
  methods: {
    /** The "+" of a document type, when the crematorium issues that type. */
    newRouteFor(docType, routeName) {
      if (this.isCustomerUser || !this.availableDocs.includes(docType)) {
        return null
      }
      return routeName
    }
  }
}
</script>
